import React from 'react'
import { Link } from 'react-router-dom'

import './index.less'

function Title(data = {}) {
  return (
    <div className="icon">
      {data.topic ? <Link to={'/detail/' + data.id}>
          {`【${data.topic && data.topic.name}】${data.title}`}
      </Link> : <Link to={'/detail/' + data.id}>
        {data.title}
      </Link>}
      {data.isNew === 1 && <img className="new" alt="" src={require('../../static/new.svg')} />}
      {data.isHot === 1 && <img className="hot" alt="" src={require('../../static/fire.svg')} />}
    </div>
  )
}

export default Title
